<template>
  <div>
   
   
    
    <v-app-bar dark>
         <v-app-bar-nav-icon v-if="isUserAuth"  class="grey--text" @click="drawer = !drawer" ></v-app-bar-nav-icon>
        <v-toolbar-title class="text-uppercase white--text" >
             <span style="font-weight:300" > Barbearia</span> <strong>Lisboa</strong>  
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">

            <v-btn v-for="item in menu" :key="item.nome" text color="white" router :to="item.rota" :v-if="item.showOnAuth || isUserAuth == false" >
                <span>{{ item.nome }}</span>
            </v-btn>

           

        </div>
        
        

           
        <div v-if="isUserAuth" class="d-flex align-center" >
             <v-btn
                 v-if="podeVerMensagens"
                 icon
                 color="white"
                 router
                 to="/admin/mensagens"
                 aria-label="Mensagens não lidas"
                 title="Mensagens não lidas"
             >
                 <v-badge
                     :content="countMessages"
                     :value="countMessages > 0"
                     color="red"
                     overlap
                 >
                     <v-icon>mdi-bell</v-icon>
                 </v-badge>
             </v-btn>
             <!-- <v-btn text color="white" router to="/admin/home">
            <span> Área admin</span>
                    </v-btn>
                    -->
            <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                color="white" 
                dark 
                v-bind="attrs"
                v-on="on" text >
                {{  getCurrentUser.name.split(" ")[0] }} 
                </v-btn>
            </template>
            <v-list>
                <v-list-item >
                <v-list-item-title @click="logoutAction">
                    <v-btn text><v-icon color="black" left @click="logoutAction">fa fa-sign-out-alt</v-icon>Sair</v-btn>
                </v-list-item-title>
                </v-list-item>
            </v-list>
            </v-menu>
            <!--<v-btn text color="white" router to="/admin/home">  
            <span> {{  getCurrentUser.name.split(" ")[0] }}</span>
            </v-btn> -->
        </div>

        <div>

            <v-app-bar-nav-icon class="d-flex d-sm-none" @click.stop="rightDrawer = !rightDrawer"></v-app-bar-nav-icon>

        </div>
    </v-app-bar>

     <v-navigation-drawer v-if="isUserAuth"  v-model="drawer" app class="indigo lighten-1 ">
        <v-layout column align-center>
            <v-flex class="mt-5" >
                <v-avatar size="100">
                    <img src="/imgs/barbeiro_perfil.jpg" alt="">
                </v-avatar>
            </v-flex>
                <p class="white--text" v-if="isUserAuth" >{{  getCurrentUser.name }}</p>

            </v-layout>
        <v-list>
            <v-list-item v-for="link in links" :key="link.text" router :to="link.route">

            <v-list-item v-if="$store.getters.userLevel >= link.lvl"   >
                <v-list-item-action>
                    <v-icon class="white--text" >{{link.icon}}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title class="white--text" >
                        {{ link.text }} 
                        
                        <div v-if="link.text == 'Mensagens'">
                            <span v-if="countMessages > 0" >
                                <v-btn icon class="red white--text">{{ countMessages }}</v-btn>
                                </span>                        
                            </div>
                    </v-list-item-title>
                </v-list-item-content>
                
            </v-list-item> 
            </v-list-item>
        </v-list>
    </v-navigation-drawer>

     <v-navigation-drawer :disable-resize-watcher="true"  v-model="rightDrawer" app right class="grey darken-1 hidden-sm-and-up">
       
            <v-list dense>
        <v-list-item
          v-for="item in menu"
          :key="item.nome"
          router :to="item.rota" :v-if="item.showOnAuth || isUserAuth == false"
        >
          <!-- <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon> -->

          <v-list-item-content class="text-center white--text" >
            <v-list-item-title>{{ item.nome }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    
   
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {refMensagens} from '@/firebaseConfig'
import CryptoJS from 'crypto-js'

    export default {
        data(){
            return{
               drawer: false,
               rightDrawer: false,
               refMensagens: refMensagens,
                countMessages: 0,
                unsubscribeMensagens: null,
                links: [
                    
                    {icon: 'mdi-view-dashboard', text: "Área administrativa", route:"/admin/home", lvl: 3, count: 0},
                    {icon: 'mdi-cash-multiple', text: "Controle financeiro", route:"/admin/financeiro", lvl: 5, count: 0},
                    {icon: 'fa fa-calendar', text: "Agenda", route:"/admin/agenda", lvl: 0, count: 0},
                    {icon: 'mdi-cards', text: "Fidelidade", route:"/admin/fidelidade", lvl: 3, count: 0},
                    {icon: 'mdi-account', text: "Barbeiros", route:"/admin/barbeiros", lvl: 3, count: 0},
                    {icon: 'mdi-folder', text: "Funções/Atividades", route:"/admin/funcoes", lvl: 3, count: 0},
                    {icon: 'mdi-email', text: "Mensagens", route:"/admin/mensagens", lvl: 3, count: this.countMessages},
                    {icon: 'mdi-calendar', text: "Feriados", route:"/admin/feriados", lvl: 3, count: 0},
                    {icon: 'mdi-image', text: "Fotos", route:"/admin/fotos", lvl: 3, count: 0},
                    {icon: 'mdi-engine', text: "Configurações", route:"/admin/configuracoes", lvl: 3, count: 0},
                    
                  
                ],
                menu: [
                    {nome: "Home", rota: "/", showOnAuth: true},
                    {nome: "Sobre", rota: "/sobre", showOnAuth: false},
                    {nome: "Contato", rota: "/contato", showOnAuth: false},
                ],
            }
        },
        computed: {
        ...mapGetters(["getCurrentUser", "getLoadingState","getLoginError","isUserAuth"]),
            podeVerMensagens(){
                return this.isUserAuth && this.$store.getters.userLevel >= 3
            },
            chaveUsuarioMensagens(){
                const usuario = this.getCurrentUser
                const identificador = usuario && (usuario.email || usuario.uid)
                return identificador
                    ? CryptoJS.MD5(String(identificador).trim().toLowerCase()).toString()
                    : null
            }

        },
        watch: {
            podeVerMensagens: {
                immediate: true,
                handler(podeVer){
                    if(podeVer){
                        this.monitorarMensagens()
                    }else{
                        this.pararMonitoramentoMensagens()
                    }
                }
            }
        },
        mounted(){
            
            
        },
        // A sessão é restaurada no main.js, antes do app montar — não há mais
        // motivo para o Navbar disparar isso.
        beforeDestroy(){
            this.pararMonitoramentoMensagens()
        },
        methods: {
            ...mapActions([ "logout"]),
            monitorarMensagens(){
                this.pararMonitoramentoMensagens()
                this.unsubscribeMensagens = this.refMensagens
                    .orderBy("hora", "desc")
                    .onSnapshot(snap => {
                        const chaveUsuario = this.chaveUsuarioMensagens
                        this.countMessages = chaveUsuario
                            ? snap.docs.filter(doc => this.mensagemNaoLidaParaUsuario(doc.data(), chaveUsuario)).length
                            : 0
                    }, error => {
                        console.error("Erro ao monitorar mensagens não lidas:", error)
                    })
            },
            mensagemNaoLidaParaUsuario(mensagem, chaveUsuario){
                if(Array.isArray(mensagem.lidaPor)){
                    return !mensagem.lidaPor.includes(chaveUsuario)
                }

                return mensagem.lida === false
            },
            pararMonitoramentoMensagens(){
                if(this.unsubscribeMensagens){
                    this.unsubscribeMensagens()
                    this.unsubscribeMensagens = null
                }
                this.countMessages = 0
            },
            logoutAction(){
                this.logout()
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
